import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.link');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-link',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.link/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageLinkComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public buttons = [
        {
            name: 'M-pro',
            url: 'https://solution.inspectpro.seasonai.net/main',
            color: 'bg-blue-300 hover:bg-blue-400',
            borderColor: 'ring-blue-200',
        },
        {
            name: 'Inspect-pro\n/ CL-pro',
            url: 'https://safety.inspectpro.seasonai.net/home',
            color: 'bg-emerald-300 hover:bg-emerald-400',
            borderColor: 'ring-emerald-200',
        },
        {
            name: 'F-pro',
            url: 'https://portal.isri.co.kr',
            color: 'bg-amber-300 hover:bg-amber-400',
            borderColor: 'ring-amber-200',
        },
        {
            name: 'Autocheck\n-pro',
            url: 'https://check.inspect.seasonai.net',
            color: 'bg-rose-300 hover:bg-rose-400',
            borderColor: 'ring-rose-200',
        },
        {
            name: 'NicePQ-pro',
            url: 'http://pq.isri.co.kr',
            color: 'bg-violet-300 hover:bg-violet-400',
            borderColor: 'ring-violet-200',
        },
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public open(url: string) {
        window.open(url, '_blank');
    }
}

export default PageLinkComponent;